import React from "react";
import { useTranslation } from "react-i18next";

export default function YearlySurveyStatistics({ schoolId }) {
  const { t } = useTranslation();

  return (
    <div className="container-fluid">
      <div className="text-center mt-5">
        <h3 className="text-muted mb-4">
          {t("teacher.surveyStatistics.yearlySurvey") || "학년도설문 통계"}
        </h3>
        <div className="card">
          <div className="card-body">
            <h5 className="card-title text-muted">
              {t("teacher.surveyStatistics.developmentInProgress") ||
                "개발 예정입니다"}
            </h5>
            <p className="card-text text-muted">
              {t("teacher.surveyStatistics.yearlySurveyDescription") ||
                "학년도별 설문 통계 기능은 곧 추가될 예정입니다."}
            </p>
            <small className="text-muted">
              {t("teacher.surveyStatistics.comingSoon") || "Coming Soon..."}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}
